import { promptToCopywriterMessages } from '$lib/ai/post/utils/promptToCopywriterMessages';
import type { AICopywriterPostChild } from '$lib/types/AICopywriter/types';
import type { AssistantClient } from '$lib/types/AssistantClient';

export const sendPromptToAssistant = async (
	prompt: string,
	assistantClient: AssistantClient,
	editorPostChildren?: AICopywriterPostChild[]
) => {
	// Each prompt is sent as a new conversation to prevent confusion with previous messages in the agent's context
	const startNewConversation = true;

	await assistantClient.sendMessage(
		promptToCopywriterMessages(prompt, editorPostChildren),
		startNewConversation
	);
};
